<div class="pg-mobile-side slideout-menu slideout-menu-right" id="pgLayoutProfileContainer">
  <shared-account-menu
    [Device]="DTypes.Mobile"
    [Roles]="onUserRole ? AccountMenuRoles.User : AccountMenuRoles.Partner"
    *ngIf="(deviceValue | async) === DTypes.Mobile || (deviceValue | async) === DTypes.Tablet">
  </shared-account-menu>
</div>
